import $ from 'jquery'
import AOS from 'aos';
import 'aos';
import 'aos/dist/aos.css';
import 'aos/dist/aos.js'
import 'lity'
import 'lity/dist/lity.css'

const contactCheck = document.querySelector(".contact-us");


// const $scrollAnimated = `.detail-page__inner h1, .detail-page__inner h2, .detail-page__inner h3, .detail-page__inner h4, .detail-page__inner img, .detail-page__inner p, .detail-page__inner a, .detail-page__inner span , .img-txt__partners h2, .img-txt__partners h3, .img-txt__partners h4, .img-txt__partners a, .img-txt__partners span, .img-txt__partners p, .img-txt__partners img, .txt-img-icon p ,.txt-img-icon a,.txt-img-icon img,.txt-img-icon span,.txt-img-icon h1,.txt-img-icon h2,.txt-img-icon h3,.txt-img-icon h4,.card-txt-img__list-card-wrapper img,.card-txt-img__list-card-wrapper p,.card-txt-img__list-card img, .card-txt-img__list-card p`;

if (contactCheck === null) {
    AOS.init({
        startEvent : 'load',
        once: true,
        initClassName: 'aos-init'
    });

    // $($scrollAnimated).attr({
    //     'data-aos': 'fade-up',
    //     'data-aos-easing': 'ease-in-out',
    //     'data-aos-duration':'500'
    // });

    AOS.refreshHard();
}

$('.slider-img-txt__slider-wrapper-mobile a').on('click',function (e) {
   $('.slider-img-txt__popup-mobile').fadeIn(300);
   e.preventDefault();
});

// document.addEventListener('contextmenu', event => event.preventDefault());

$('img').on('dragstart', function(event) { event.preventDefault(); });
$("body").on("contextmenu", "img", function(e) {
    return false;
});